import type { GeoJSONSource, Map as MaplibreMap } from 'maplibre-gl';
import type { FeatureEndpoints } from './OgcServicesContext';
import type { OgcFeaturesClient } from './ogc-features-client';

export async function loadViewportFeatureOverlay(
  map: MaplibreMap,
  featuresClient: Pick<OgcFeaturesClient, 'searchByBbox'>,
  collection: keyof FeatureEndpoints,
  sourceId: string,
  limit = 5000,
): Promise<number> {
  const bounds = map.getBounds();
  const bbox: [number, number, number, number] = [
    bounds.getWest(), bounds.getSouth(), bounds.getEast(), bounds.getNorth(),
  ];
  const features = await featuresClient.searchByBbox(collection, bbox, limit);
  const source = map.getSource(sourceId) as GeoJSONSource | undefined;
  if (!source) throw new Error('Map overlay source is unavailable');
  source.setData(features);
  return features.features.length;
}
